import React from 'react';

const Docs = () => {
    return(
        <>
            <div className="docs-main">
                <iframe src="https://v2-embednotion.com/eacec70711124f5ebe63470a61cbfbfe" style={{width: '100vw', height: '100vh', border: 'none', marginTop: '0.5rem'}} />
            </div>
        </>
    )
}

export default Docs